import { Client } from "@/Common/Api/Client";
import { ClientResponse } from "@/Common/Api/ClientResponse";
import { GenericResponse } from "@/Common/Api/Dto/GenericResponse";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { ICommonDataSetExportRequest } from "./Dto/CommonDataSetExportRequest";
import { ICommonDataSetImportRequest } from "./Dto/CommonDataSetImportRequest";

class CommonDataSetExportApi {
    public static createCommonDataSetExport(request: ICommonDataSetExportRequest): Promise<ClientResponse<GenericResponse>> {
        return Client.postAsync<GenericResponse>(
            ServerOperations.Server.Myle_CDSExport_SaveOntarioCommonDataSetExport,
            request
        );
    }

    public static createCommonDataSetImport(request: ICommonDataSetImportRequest): Promise<ClientResponse<GenericResponse>> {
        return Client.postFiles<GenericResponse>(
            "/api/cds/import",
            [request.File],
            request
        );
    }
}

export { CommonDataSetExportApi };
